import Navbar from "../components/Navbar";
import HomeHero from "../components/HomeHero";
import AboutUs from "../components/AboutUs";
import Footer from "../components/Footer";
import AboutImg from "../assets/night.jpg";
import Background from "src/components/Background";

function About() {
  return (
    <>
      <Navbar />
      {/* <Background /> */}
      {/* <HomeHero
        cName="hero-mid"
        heroImg={AboutImg}
        title="About"
        btnClass="hide"
      /> */}
      <AboutUs />
      <Footer />
    </>
  );
}

export default About;
